import React from 'react';
import { useLocation } from "react-router-dom";
import LabsAppBar from "@components/LabsAppBar";
import { ActionButton } from '@components/LabsAppBar';
import SchemaDiagram from '@components/labs/SchemaDiagram'; // Assuming this component is still relevant for the overview

const LabsOverviewPage: React.FC = () => {
  const location = useLocation();

  let breadcrumbs = [];
  let actions: ActionButton[] = [];
  let pageTitle = '';
  let pageIcon: string | undefined;

  // The default path for /labs will now point to this page
  switch (location.pathname) {
    case '/labs':
    case '/labs/overview': // Explicitly handle /labs/overview if it's ever used
      // pageTitle = 'Overview Page';
      // pageIcon = 'Monitoring'; // Using 'Monitoring' icon as per LabsNavbar
      actions = [
        // { label: 'New Schema', onClick: () => console.log('New Schema clicked'), iconName: 'PlusCircle', variant: 'primary' },
      ];
      break;
    default:
      pageTitle = 'Overview Page';
      pageIcon = 'Monitoring';
      actions = [];
      break;
  }

  breadcrumbs = [{ name: pageTitle, iconName: pageIcon }];

  return (
    <div className="flex flex-col h-full">
      <LabsAppBar
        breadcrumbs={breadcrumbs}
        actions={actions}
      />
      <div className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8 flex flex-col items-center">
        <div className="max-w-4xl w-full space-y-8 text-center mb-8">
          <div>
            <h1 className="text-3xl font-extrabold text-gray-900 dark:text-white">
              Welcome to 🧪 the lab!
            </h1>
            <p className="mt-2 text-gray-600 dark:text-gray-300">
               Our playground for wild ideas, rapid developement, and UI + AI experiments.
            </p>
          </div>
        </div>
        <div className="bg-white dark:bg-gray-800 shadow overflow-hidden sm:rounded-lg p-8 w-full max-w-5xl text-center">
          <SchemaDiagram />
        </div>
      </div>
    </div>
  );
};

export default LabsOverviewPage;
